import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { StorageService } from '../services';

export const authGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (storageService.storage().user) {
    return true;
  }

  return router.navigateByUrl('/sign-in');
};
